<template>
    <div class="industries">
        <div v-if="isTabsInitialized">
            <v-tabs v-model="tab"
                    v-if="!isIndustryDetail"
                    next-icon="mdi-arrow-right-bold-box-outline"
                    prev-icon="mdi-arrow-left-bold-box-outline"
                    show-arrows>
                <v-tabs-slider></v-tabs-slider>
                <v-tab v-for="(item, index) in items" :key="index">
                    <span>
                           {{ item.label }}
                    </span>
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item v-for="(item, index) in items" :key="index">
                    <div v-if="item.packageType && item.packageType.length">
                        <div class="industries__list">
                            <div v-for="(packageType, id) in item.packageType" :key="id" class="industries__item">
                                <div class="industries__card">
                                    <img class="industries__img" :src="packageType.img" :alt="packageType.name">
                                    <h3 class="industries__title">{{ packageType.name }}</h3>
                                    <a class="industries__link" :href="packageType.url"></a>
                                </div>
                            </div>
                        </div>

                        <div
                                v-if="
                            ($vuetify.breakpoint.width > 1650 && item.packageType.length > 6) ||
                            ($vuetify.breakpoint.width <= 1650 && $vuetify.breakpoint.width > 1500 && item.packageType.length > 5) ||
                            ($vuetify.breakpoint.width <= 1500 && $vuetify.breakpoint.width > 1024 && item.packageType.length > 4) ||
                            ($vuetify.breakpoint.width <= 1024 && $vuetify.breakpoint.width > 768 && item.packageType.length > 3) ||
                            ($vuetify.breakpoint.width <= 768 && $vuetify.breakpoint.width > 550 && item.packageType.length > 2) ||
                            ($vuetify.breakpoint.width <= 550 && item.packageType.length > 1)"
                                class="industries__arrows"
                        >
                            <button class="industries__arrow industries__arrow--prev"
                                    @click="prevSlide(index)"></button>
                            <button class="industries__arrow industries__arrow--next"
                                    @click="nextSlide(index)"></button>
                        </div>
                    </div>
                </v-tab-item>
            </v-tabs-items>
        </div>

        <div class="package-properties">
            <div class="package-properties__item">
                <img src="/upload/recommend-1.png" alt="">
                <p>Упаковка с маркировкой <br> Честный знак</p>
            </div>
            <div class="package-properties__item">
                <img src="/upload/recommend-2.png" alt="">
                <p>Устойчивая упаковка</p>
            </div>
            <div class="package-properties__item">
                <img src="/upload/recommend-3.png" alt="">
                <p>Упаковка по стандартам <br> Халяль</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "industries",
    props: {
        branches: Array | Object | String,
    },
    data() {
        return {
            tab: null,
            isTabsInitialized: false,
            isIndustryDetail: false,
            items: this.branches,
            /*items: [
                {
                    label: 'Пищевая упаковка',
                    packageType: [

                        {
                            img: '/upload/iblock/17a/ihqoxr1bkckwx2fd16901527ax9c4lsh.png',
                            name: 'Рыба, морепродукты',
                            url: ''
                        },
                        {
                            img: '/upload/iblock/17a/ihqoxr1bkckwx2fd16901527ax9c4lsh.png',
                            name: 'Рыба, морепродукты',
                            url: ''
                        },
                        {
                            img: '/upload/iblock/90a/g9080m5ze1h17w3t39mtk6wvw9lozhlt/Kotlety-Krylya-Sborka.png',
                            name: 'Мясо, птица',
                            url: ''
                        },
                        {
                            img: '/upload/iblock/a51/oq23bbkz402u7nwyzqpyq1je3x16d296.jpg',
                            name: 'Молочная продукция',
                            url: ''
                        },
                        {
                            img: '/upload/iblock/ec1/1h51yx9dyfgbh22rm3uqz77desb7wd1f.jpg',
                            name: 'Замороженная продукция',
                            url: ''
                        },
                        {
                            img: '/upload/iblock/e1e/7hsythdrpn070tqw3bmsfg61t29ko7kt.png',
                            name: 'Кондитерские, хлебобулочные изделия',
                            url: ''
                        },
                    ]
                },
                {
                    label: 'Непищевая упаковка',
                    packageType: [
                        {
                            img: '/upload/iblock/d1f/829v5smvx57l0hx7zklwk19tbadjjwx1.png',
                            name: 'Упаковка для чая',
                            url: ''
                        },
                        {
                            img: '/upload/iblock/ec1/1h51yx9dyfgbh22rm3uqz77desb7wd1f.jpg',
                            name: 'Замороженная продукция',
                            url: ''
                        },
                        {
                            img: '/upload/iblock/17a/ihqoxr1bkckwx2fd16901527ax9c4lsh.png',
                            name: 'Рыба, морепродукты',
                            url: ''
                        },
                        {
                            img: '/upload/iblock/90a/g9080m5ze1h17w3t39mtk6wvw9lozhlt/Kotlety-Krylya-Sborka.png',
                            name: 'Мясо, птица',
                            url: ''
                        },
                        {
                            img: '/upload/iblock/a51/oq23bbkz402u7nwyzqpyq1je3x16d296.jpg',
                            name: 'Молочная продукция',
                            url: ''
                        },
                        {
                            img: '/upload/iblock/e1e/7hsythdrpn070tqw3bmsfg61t29ko7kt.png',
                            name: 'Кондитерские, хлебобулочные изделия',
                            url: ''
                        },
                    ]
                },
                {
                    label: 'Упаковка товаров для животных',
                    packageType: [
                        {
                            img: '/upload/iblock/d1f/829v5smvx57l0hx7zklwk19tbadjjwx1.png',
                            name: 'Упаковка для чая',
                            url: ''
                        },
                        {
                            img: '/upload/iblock/ec1/1h51yx9dyfgbh22rm3uqz77desb7wd1f.jpg',
                            name: 'Замороженная продукция',
                            url: ''
                        },
                        {
                            img: '/upload/iblock/17a/ihqoxr1bkckwx2fd16901527ax9c4lsh.png',
                            name: 'Рыба, морепродукты',
                            url: ''
                        },
                        {
                            img: '/upload/iblock/90a/g9080m5ze1h17w3t39mtk6wvw9lozhlt/Kotlety-Krylya-Sborka.png',
                            name: 'Мясо, птица',
                            url: ''
                        },
                        {
                            img: '/upload/iblock/a51/oq23bbkz402u7nwyzqpyq1je3x16d296.jpg',
                            name: 'Молочная продукция',
                            url: ''
                        },
                        {
                            img: '/upload/iblock/e1e/7hsythdrpn070tqw3bmsfg61t29ko7kt.png',
                            name: 'Кондитерские, хлебобулочные изделия',
                            url: ''
                        },
                    ]
                },
            ]*/

        }
    },
    methods: {
        prevSlide(index) {
            const $currentSlider = $('.v-window-item--active .industries__list');
            if ($currentSlider.hasClass('slick-initialized')) {
                $currentSlider.slick('slickPrev');
            }
        },
        nextSlide(index) {

            const $currentSlider = $('.v-window-item--active .industries__list');
            if ($currentSlider.hasClass('slick-initialized')) {
                $currentSlider.slick('slickNext');
            }
        }
    },

    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.isTabsInitialized = true;
            }, 50);
        });

        this.$nextTick(() => {
            setTimeout(() => {
                $('.industries__list').slick({
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    infinite: false,
                    arrows: false,
                    dots: false,
                    responsive: [
                        {breakpoint: 1650, settings: {slidesToShow: 5}},
                        {breakpoint: 1500, settings: {slidesToShow: 4}},
                        {breakpoint: 1024, settings: {slidesToShow: 3}},
                        {breakpoint: 768, settings: {slidesToShow: 2}},
                        {breakpoint: 550, settings: {slidesToShow: 1}}
                    ]
                });
            }, 150);
        });


    },

    watch: {
        tab() {
            this.$nextTick(() => {

                setTimeout(() => {
                    const $slider = $('.industries__list');

                    $slider.each(function () {
                        const currentSlider = $(this);

                        if (currentSlider.hasClass('slick-initialized')) {

                            currentSlider.slick('setPosition');
                        } else {
                            currentSlider.slick({
                                slidesToShow: 6,
                                slidesToScroll: 1,
                                infinite: false,
                                arrows: true,
                                dots: false,
                                responsive: [
                                    {breakpoint: 1650, settings: {slidesToShow: 5}},
                                    {breakpoint: 1500, settings: {slidesToShow: 4}},
                                    {breakpoint: 1024, settings: {slidesToShow: 3}},
                                    {breakpoint: 768, settings: {slidesToShow: 2}},
                                    {breakpoint: 550, settings: {slidesToShow: 1}}
                                ]
                            });
                        }
                    });
                }, 100);
            });
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep {
  .slick-track {
    display: flex !important;
    justify-content: flex-start !important;
    margin-left: 0 !important;
    margin-right: auto !important;
  }

  .slick-slide {
    height: auto !important;
    display: flex !important;

    & > div {
      display: flex !important;
      height: 100%;
      width: 100%;
    }
  }

}

.industries {
  &__list {
    max-height: 320px;
    margin-bottom: 40px;
  }

  &__arrows {
    display: flex;
    justify-content: center;
    gap: 16px;
    width: 100%;

  }

  &__arrow {
    width: 56px;
    height: 56px;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #E1E1E2;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    outline: none;
    padding: 0;

    &:hover {
      border-color: #4F4D55;
    }

    &::before {
      content: '';
      width: 10px;
      height: 10px;
      background: url(/local/templates/international/img/fi_chevron-down.svg) no-repeat center;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &--prev {
      &::before {
        transform: rotate(180deg);

      }
    }

    &--next {
      &::before {
        transform: rotate(0);
        margin-right: 3px;
      }
    }
  }

  &__item {
    box-sizing: border-box;
    display: flex !important;
    padding: 0 4px !important;
    height: 100%;
  }

  &__card {
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 280px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 32px;
    padding: 24px;
    border: 1px solid #E8E8E8;
    transition: all 0.2s ease;

    &:hover {
      border-color: #f94237;
    }

    &:has(.industries__link:hover) {
      .industries__title {
        color: #f94237;
      }
    }
  }

  &__link {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &__img {
    width: 100%;
    max-width: 200px;
    height: 100%;
    max-height: 150px;
    object-fit: cover;
  }

  &__title {
    font-family: "MuseoSansCyrl-500";
    font-weight: 400;
    font-size: 24px;
    line-height: 28px;
    letter-spacing: 0px;
    color: #212424;
    margin: 0;
    white-space: normal !important;
    word-break: break-word !important;
    transition: all 0.2s ease;
  }

  & .package-properties {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    padding-top: 60px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 24px;
    }

    &__item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #E6E6E6;
      padding: 0 8px;
      gap: 12px;

      &:last-of-type {
        border-right: none;
      }

      @media (max-width: 768px) {
        border-right: none;
      }

      & img {
        width: 120px;
        height: 120px;
        display: inline-block;

      }

      & p {
        font-family: 'MuseoSansCyrl-500';
        font-weight: 400;
        font-style: 500;
        font-size: 24px;
        line-height: 28px;
        letter-spacing: 0px;
        text-align: center;
        vertical-align: middle;
        color: #4F4D55;
        margin-bottom: 0 !important;
      }
    }
  }
}
</style>

<style lang="scss">

.industries {

  .v-tab:not(.v-tab--active) {
    & svg {
      display: none;
    }
  }

  .v-ripple__container {
    display: none;
  }

  & .v-tabs-slider {
    height: 0;
  }

  & .v-tabs:not(.v-tabs--vertical):not(.v-tabs--right) > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes) .v-slide-group__prev {
    display: none;

  }

  .v-tabs {
    @media (max-width: 766px) {
      max-width: 90vw;
    }
  }

  & .v-tab {
    gap: 14px;
    margin: 5px;
    border: 1px solid #E4E4E4;
    background: #FFFFFF;
    border-radius: 40px;
    padding: 12px 24px;
    height: 52px;
    width: 100%;
    min-width: max-content;

    &:before {
      background-color: transparent !important;
    }

    &:hover {
      opacity: 1 !important;
      border-color: #4F4D55;
    }

    & > span {
      font-family: 'MuseoSansCyrl-500';
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
      letter-spacing: 0;
      color: #4F4D55 !important;
      text-transform: none;

      @media (max-width: 550px) {
        font-size: 18px;
        line-height: 24px;
      }
    }

    &--active {
      border: 1px solid #FA4237;

      &:before {
        background-color: transparent !important;
      }

      &:hover {
        opacity: 1 !important;
        border-color: #FA4237;
      }

      & > span {
        color: #FA4237 !important;
      }
    }

  }

  .v-slide-group__content {
    gap: 8px;
  }

  & .v-item-group {
    margin-top: 20px;

    .theme--light.v-card {
      background-color: transparent;
    }
  }

  & .v-item-group.v-tabs-items {
    box-shadow: none !important;
  }

  & .v-slide-group__wrapper {
    height: 75px;
  }

  & .theme--light.v-tabs > .v-tabs-bar {
    height: 60px;
  }

  & .v-tabs-bar,
  & .theme--light.v-tabs-items {
    background-color: transparent !important;
  }

  .v-slide-group:not(.v-slide-group--has-affixes) > .v-slide-group__prev, .v-slide-group:not(.v-slide-group--has-affixes) > .v-slide-group__next {
    display: none;
  }

  & .mdi-arrow-right-bold-box-outline::before {
    content: '';
    background: url("/upload/chevron-right.svg") no-repeat;
    background-size: contain;
    width: 40px;
    height: 40px;
  }

  & .mdi-arrow-left-bold-box-outline::before {
    content: '';
    background: url("/upload/chevron-right.svg") no-repeat;
    background-size: contain;
    width: 40px;
    height: 40px;
    rotate: 180deg;
  }

  & .v-slide-group__next, .v-slide-group__prev {
    min-width: 33px;
  }
}

</style>